const cyNavList = [
    // {
    //   id: 100,
    //   name: '首页',
    //   // path:'/sy/sy',
    //   children: [
    //     {
    //     id: 100001,
    //     path: '/sy/sy',
    //     name: '首页',
    //   },
    //   // {
    //   //   id: 100002,
    //   //   path: '',
    //   //   name: '页面设计',
    //   // }, {
    //   //   id: 100003,
    //   //   path: '',
    //   //   name: '数据配置',
    //   // }
    //   ]
    // },
    // {
    //   id: 10,
    //   name: "商店",
    //   img: require('@/assets/img/shopNav.png'),
    //   act_img: require('@/assets/img/shopNav.png'),
    //   path: '/shop',
    //   data: [{
    //     id: 100,
    //     name: '商店',
    //     children: [{
    //       id: 100001,
    //       path: '/shop',
    //       name: '线上商店',
    //       navTitle: "商店 / 线上商店"
    //     },]
    //   },]
    // },
    {
        id: 10,
        name: "概况",
        img: require('@/assets/img/bbNav.png'),
        act_img: require('@/assets/img/actBbNav.png'),
        path: '/BusinessOverview',
        authId: 'gk',

        data: [
            //   {
            //   id: 100,
            //   name: '概况',
            //   children: [{
            //     id: 100001,
            //     path: '/BusinessOverview',
            //     name: '概况',
            //     navTitle: "概况 / 概况"
            //   }]
            // }
        ]
    },
    {
        id: 60,
        name: "菜品",
        img: require('@/assets/img/jcNav.png'),
        act_img: require('@/assets/img/actJcNav.png'),
        path: '/cpNav',
        authId: '',
        data: [{
            id: 609,
            name: '菜品导航',
            isNav: true,

            children: [{
                id: 609001,
                path: '/cpNav',
                name: '菜品导航',
                navTitle: "菜品导航 / 菜品导航",
                authId: '',
                isNav: true

            },]
        }, {
            id: 602,
            name: '菜品',
            children: [{
                id: 602006,
                path: '/proCls',
                name: '菜品分类',
                navTitle: "菜品管理 / 菜品分类",
                navImg: require('@/assets/img/nav/lsNavIcon/jc/spfl.png'),
                introduction: "菜品分类管理",
                authId: 'cp_cpfl'
            },{
                id: 602001,
                path: '/dish',
                name: '菜品信息',
                navTitle: "菜品信息 / 菜品信息",
                navImg: require('@/assets/img/nav/cpxx.png'),
                introduction: "菜品信息管理",
                authId: 'cp_cpxx',

            },
            
            // {
            //   id: 602002,
            //   path: '/combo',
            //   name: '套餐信息',
            //   navTitle: "菜品信息 / 套餐信息",
            //   navImg: require('@/assets/img/nav/tcxx.png'),
            //   introduction: "套餐信息管理",
            //   authId: 'cpgl',
            // },
        //    {
        //         id: 602008,
        //         path: '/flavCls',
        //         name: '做法分类',
        //         navTitle: "菜品配置 / 做法分类",
        //         navImg: require('@/assets/img/nav/zfxx.png'),
        //         introduction: "做法分类管理",
        //         authId: 'cp_zfxx',
        //     },  {
        //         id: 602003,
        //         path: '/flav',
        //         name: '做法信息',
        //         navTitle: "菜品配置 / 做法信息",
        //         navImg: require('@/assets/img/nav/zfxx.png'),
        //         introduction: "做法信息管理",
        //         authId: 'cp_zfxx',
        //     }, {
        //         id: 602007,
        //         path: '/feedCls',
        //         name: '加料分类',
        //         navTitle: "菜品配置 / 加料分类",
        //         navImg: require('@/assets/img/nav/zfxx.png'),
        //         introduction: "加料分类管理",
        //         authId: 'cp_zfxx',
        //     }, {
        //         id: 602004,
        //         path: '/feed',
        //         name: '加料信息',
        //         navTitle: "菜品配置 / 加料信息",
        //         navImg: require('@/assets/img/nav/jlxx.png'),
        //         introduction: "加料信息管理",
        //         authId: 'cp_jlxx',

        //     },
            
        //     {
        //         id: 602005,
        //         path: '/unit',
        //         name: '单位信息',
        //         navTitle: "菜品配置 / 单位信息",
        //         navImg: require('@/assets/img/nav/jlxx.png'),
        //         introduction: "单位信息管理",
        //         authId: 'cp_dwxx',

        //     },
            ]
        },
        {
            id: 603,
            name: '菜品配置',
            children: [
           {
                id: 603008,
                path: '/flavCls',
                name: '做法分类',
                navTitle: "菜品配置 / 做法分类",
                navImg: require('@/assets/img/nav/zfxx.png'),
                introduction: "做法分类管理",
                authId: 'cp_zffl',
            },  {
                id: 603003,
                path: '/flav',
                name: '做法信息',
                navTitle: "菜品配置 / 做法信息",
                navImg: require('@/assets/img/nav/zfxx.png'),
                introduction: "做法信息管理",
                authId: 'cp_zfxx',
            }, {
                id: 603007,
                path: '/feedCls',
                name: '加料分类',
                navTitle: "菜品配置 / 加料分类",
                navImg: require('@/assets/img/nav/zfxx.png'),
                introduction: "加料分类管理",
                authId: 'cp_jlfl',
            }, {
                id: 603004,
                path: '/feed',
                name: '加料信息',
                navTitle: "菜品配置 / 加料信息",
                navImg: require('@/assets/img/nav/jlxx.png'),
                introduction: "加料信息管理",
                authId: 'cp_jlxx',

            },
            
            {
                id: 603005,
                path: '/unit',
                name: '单位信息',
                navTitle: "菜品配置 / 单位信息",
                navImg: require('@/assets/img/nav/jlxx.png'),
                introduction: "单位信息管理",
                authId: 'cp_dwxx',

            },
            ]
        },
        {
            id: 601,
            name: '厨打设置',
            children: [

                {
                    id: 601003,
                    path: '/print',
                    name: '打印机',
                    navTitle: "厨打设置 / 打印机",
                    navImg: require('@/assets/img/nav/dygl.png'),
                    introduction: "打印机设置",
                    authId: 'cp_dyj',

                },
                {
                    id: 601004,
                    path: '/printCpk',
                    name: '出票口',
                    navTitle: "厨打设置 / 出票口",
                    navImg: require('@/assets/img/nav/cpk.png'),
                    introduction: "出票口设置",
                    authId: 'cp_cpk',

                },
            ]
        }
        ]
    },

    // {
    //   id: 40,
    //   name: "档案",
    //   img: require('@/assets/img/jcNav.png'),
    //   act_img: require('@/assets/img/actJcNav.png'),
    //   path: '/dish',
    //   data: []
    // },

    {
        id: 70,
        name: "餐桌",
        path: '/czNav',
        img: require('@/assets/img/czNav.png'),
        act_img: require('@/assets/img/actBbNav.png'),
        authId: '',
        data: [{
            id: 709,
            name: '餐桌导航',
            isNav: true,
            children: [{
                id: 709001,
                path: '/czNav',
                name: '餐桌导航',
                navTitle: "餐桌导航 / 餐桌导航",
                authId: '',

            },]
        }, {
            id: 703,
            name: '桌台设置',
            children: [{
                id: 703001,
                path: '/table',
                name: '餐桌信息',
                navTitle: "桌台设置 / 餐桌信息",
                navImg: require('@/assets/img/nav/czxx.png'),
                introduction: "餐桌信息管理",
                authId: 'cz_czxx',
            }, {
                id: 703002,
                path: '/tableCls',
                name: '餐桌分类',
                navTitle: "桌台设置 / 餐桌分类",
                navImg: require('@/assets/img/nav/czxx.png'),
                introduction: "餐桌分类管理",
                authId: 'cz_czfl',
            },]
        }, {
            id: 704,
            name: '扫码点单',
            children: [
                //   {
                //   id: 704002,
                //   path: '/smDcFz',
                //   name: '线上分类',
                //   navTitle: "扫码点单 / 线上分类",
                //   navImg: require('@/assets/img/nav/xsfl.png'),
                //   introduction: "扫码点餐分类",
                //   authId: 'ddfz',
                // },
                {
                    id: 704003,
                    path: '/smDcSp',
                    name: '线上商品',
                    navTitle: "扫码点单 / 线上商品",
                    navImg: require('@/assets/img/nav/xsfl.png'),
                    introduction: "扫码点餐菜品",
                    authId: 'cz_xssp',
                },
                {
                    id: 704004,
                    path: '/smDcCls',
                    name: '线上分类',
                    navTitle: "扫码点单 / 线上分类",
                    navImg: require('@/assets/img/nav/xsfl.png'),
                    introduction: "扫码点餐分类",
                    authId: 'cz_xsfl',
                },
                {
                    id: 704001,
                    path: '/smDc',
                    name: '功能设置',
                    navTitle: "扫码点单 / 功能设置",
                    navImg: require('@/assets/img/nav/gnsz.png'),
                    introduction: "扫码点餐设置",
                    authId: 'cz_gnsz',

                },
            ]
        },]
    },
    {
        id: 30,
        name: "会员",
        img: require('@/assets/img/vipNav.png'),
        act_img: require('@/assets/img/actVipNav.png'),
        path: '/hyNav',
        authId: '',

        data: [{
            id: 309,
            name: '会员导航',
            isNav: true,

            children: [{
                id: 309001,
                path: '/hyNav',
                name: '会员导航',
                navTitle: "会员导航 / 会员导航",
                authId: '',

            },]
        }, {
            id: 300,
            name: '档案信息',
            children: [{
                id: 300001,
                path: '/vip',
                name: '会员信息',
                navTitle: "档案信息 / 会员信息",
                navImg: require('@/assets/img/nav/hyxx.png'),
                introduction: "会员信息管理",
                authId: 'hy_hyxx',

            },

            {
                id: 300006,
                path: '/vipCls',
                name: '会员等级',
                navTitle: "档案信息 / 会员等级",
                navImg: require('@/assets/img/nav/hydj.png'),
                introduction: "会员等级管理",
                authId: 'hy_hydj',
            },

            // {
            //   id: 300002,
            //   path: '/vipBq',
            //   name: '会员标签',
            //   navTitle: "档案信息 / 会员标签"
            // },

            {
                id: 300007,
                path: '/vipCzFa',
                name: '充值方案',
                navTitle: "储值业务 / 充值方案",
                navImg: require('@/assets/img/nav/czfa.png'),
                introduction: "固定充值金额快速充值",
                authId: 'hy_czfa',
            },
            // {
            //     id: 300008,
            //     path: '/vipJf',
            //     name: '积分规则',
            //     navTitle: "会员管理 / 积分规则",
            //     // navImg: require('@/assets/img/nav/czfa.png'),
            //     introduction: "积分规则设置",
            //     authId: 'jfgz'
            // },
                // {
                //   id: 300004,
                //   path: '/vipBq',
                //   name: '升降记录',
                //   navTitle: "档案信息 / 升降记录"
                // },
            ]
        }, {
            id: 302,
            name: '会员报表',
            children: [
                {
                    id: 302003,
                    path: '/xfHz',
                    name: '消费汇总',
                    navTitle: "档案信息 / 消费汇总",
                    navImg: require('@/assets/img/nav/xfHz.png'),
                    introduction: "会员消费概况",
                    authId: 'hy_xfhz',
                },
                {
                    id: 302005,
                    path: '/xfMx',
                    name: '消费明细',
                    navTitle: "档案信息 / 消费明细",
                    navImg: require('@/assets/img/nav/xfMx.png'),
                    introduction: "会员消费记录",
                    authId: 'hy_xfmx',
                },
                // {
                //   id: 302003,
                //   path: '/',
                //   name: '储值授权',
                //   navTitle: "储值业务 / 储值授权"
                // },
                // {
                //   id: 302003,
                //   path: '/czMx',
                //   name: '储值明细',
                //   navTitle: "储值业务 / 储值明细"
                // },
                {
                    id: 302004,
                    path: '/yeMx',
                    name: '余额明细',
                    navTitle: "储值业务 / 余额明细",
                    navImg: require('@/assets/img/nav/yemx.png'),
                    introduction: "会员余额变动明细",
                    authId: 'hy_yemx',
                }, {
                    id: 300003,
                    path: '/jfMx',
                    name: '积分明细',
                    navTitle: "积分业务 / 积分明细",
                    navImg: require('@/assets/img/nav/jfmx.png'),
                    introduction: "会员积分变动明细",
                    authId: 'hy_jfmx',
                },
            ]
        },
        {
            id: 304,
            name: '短信营销',
            children: [{
                id: 304001,
                path: '/dxCz',
                name: '短信充值',
                navTitle: "短信营销 / 短信充值",
                navImg: require('@/assets/img/nav/dxcz.png'),
                introduction: "可进行通知营销",


            }, {
                id: 304002,
                path: '/dxMb',
                name: '短信模板',
                navTitle: "短信营销 / 短信模板",
                navImg: require('@/assets/img/nav/dxmb.png'),
                introduction: "提升商家效率",
                authId: 'hy_dxmb',

            },]
        },

            // {
            //   id: 303,
            //   name: '积分业务',
            //   children: [

            //     //   {
            //     //   id: 303001,
            //     //   path: '/vipJf',
            //     //   name: '积分规则',
            //     //   navTitle: "储值业务 / 积分规则"
            //     // }, {
            //     //   id: 303002,
            //     //   path: '/vipDhLp',
            //     //   name: '兑换礼品',
            //     //   navTitle: "档案信息 / 兑换礼品"
            //     // },
            //   ]
            // },
            // {
            //   id: 301,
            //   name: '会员运营',
            //   children: [{
            //     id: 301001,
            //     path: '/dxTz',
            //     name: '短信通知',
            //     navTitle: "会员运营 / 短信通知"
            //   }, {
            //     id: 301002,
            //     path: '/wxTz',
            //     name: '微信通知',
            //     navTitle: "会员运营 / 微信通知"
            //   }, {
            //     id: 301003,
            //     path: '/vipKq',
            //     name: '卡券管理',
            //     navTitle: "会员运营 / 卡券管理"
            //   }, {
            //     id: 301004,
            //     path: '/vipCkXm',
            //     name: '次卡项目',
            //     navTitle: "会员运营 / 次卡项目"
            //   }, {
            //     id: 301005,
            //     path: '/vipLb',
            //     name: '礼包管理',
            //     navTitle: "会员运营 / 礼包管理"
            //   },]
            // }
        ]
    },
    {
        id: 80,
        name: "营销",
        path: '/cxNav',
        img: require('@/assets/img/yxNav.png'),
        act_img: require('@/assets/img/actBbNav.png'),

        data: [{
            id: 801,
            name: '营销导航',
            isNav: true,

            children: [{
                id: 801001,
                path: '/cxNav',
                name: '营销导航',
                navTitle: "营销导航 / 营销导航",
                authId: '',

            },]
        },
        {
            id: 802,
            name: '营销设置',
            children: [{
                id: 804010,
                path: '/cxHz',
                name: '促销汇总',
                navTitle: "营销设置 / 促销汇总",
                navImg: require('@/assets/img/nav/cxhz.png'),
                introduction: "促销汇总",
                authId: 'yx_cxhz',
            }, {
                id: 804001,
                path: '/xsTj',
                name: '限时特价',
                navTitle: "营销设置 / 限时特价",
                navImg: require('@/assets/img/nav/xstj.png'),
                introduction: "设置限时特价商品",
                authId: 'yx_xstj',
            }, {
                id: 804002,
                path: '/xsZk',
                name: '限时折扣',
                navTitle: "营销设置 / 限时折扣",
                navImg: require('@/assets/img/nav/xszk.png'),
                introduction: "设置限时打折促销的商品",
                authId: 'yx_xszk',
            }, {
                id: 804003,
                path: '/mzzk',
                name: '满折促销',
                navTitle: "营销设置 / 满折促销",
                navImg: require('@/assets/img/nav/mzzk.png'),
                introduction: "购买一定数量/金额享优惠",
                authId: 'yx_mzcx',
            },
            // {
            //     id: 804004,
            //     path: '/mjcx',
            //     name: '满减促销',
            //     navTitle: "营销设置 / 满减促销",
            //     navImg: require('@/assets/img/nav/mjcx.png'),
            //     introduction: "购买一定数量/金额享优惠",
            //     authId: 'yx_mjcx',
            // },
            // {
            //     id: 804005,
            //     path: '/mzcx',
            //     name: '满赠促销',
            //     navTitle: "营销设置 / 满赠促销",
            //     navImg: require('@/assets/img/nav/mzcx.png'),
            //     introduction: "满足门槛后赠送商品或权益",
            //     authId: 'yx_mzcx',
            // },
            // {
            //     id: 804006,
            //     path: '/mmcx',
            //     name: '满免促销',
            //     navTitle: "营销设置 / 满免促销",
            //     navImg: require('@/assets/img/nav/mmcx.png'),
            //     introduction: "满足门槛后免其中一份商品",
            //     authId: 'yx_mmcx',
            // },
            // {
            //     id: 804007,
            //     path: '/jjg',
            //     name: '加价惠购',
            //     navTitle: "营销设置 / 加价惠购",
            //     navImg: require('@/assets/img/nav/jjg.png'),
            //     introduction: "满足门槛后加价换购商品",
            //     authId: 'yx_jjg',
            // },
            ]
        },
        {
            id: 803,
            name: '短信营销',
            children: [{
                id: 803003,
                path: '/dxYx',
                name: '短信营销',
                navTitle: "短信营销 / 短信营销",
                navImg: require('@/assets/img/nav/dxyx.png'),
                introduction: "精准发送营销短信",
                authId: 'yx_dxyx',
            }, {
                id: 803004,
                path: '/dxFsJl',
                name: '发送记录',
                navTitle: "短信营销 / 发送记录",
                navImg: require('@/assets/img/nav/fsjl.png'),
                introduction: "短信发送记录",
                authId: 'yx_fsjl',
            },]
        },
        {
            id: 805,
            name: '外卖',
            children: [{
                id: 805011,
                path: '/wmdd',
                name: '外卖订单',
                navTitle: "外卖 / 外卖订单",
                navImg: require('@/assets/img/nav/elmwm.png'),
                introduction: "外卖订单",
                authId: 'yx_wmdd',

            }, {
                id: 805001,
                path: '/elmwm',
                name: '饿了么外卖',
                navTitle: "外卖 / 饿了么外卖",
                navImg: require('@/assets/img/nav/elmwm.png'),
                introduction: "同步扣减库存",

            },
            {
                id: 805002,
                path: '/jdwm',
                name: '京东外卖',
                navTitle: "外卖 / 京东外卖",
                navImg: require('@/assets/img/nav/jdwm.png'),
                introduction: "同步扣减库存",

            },
            {
                id: 805003,
                path: '/mtwm',
                name: '美团外卖',
                navTitle: "外卖 / 美团外卖",
                navImg: require('@/assets/img/nav/mtwm.png'),
                introduction: "同步扣减库存",

            },
            ]
        },
        {
            id: 806,
            name: '团购',
            children: [
                //     {
                //     id: 806011,
                //     path: '/tgdz',
                //     name: '团购对账',
                //     navTitle: "团购 / 团购对账",
                //     navImg: require('@/assets/img/nav/elmwm.png'),
                //     introduction: "",

                // }, 
                {
                    id: 806001,
                    path: '/dytg',
                    name: '抖音团购',
                    navTitle: "团购 / 抖音团购",
                    navImg: require('@/assets/img/nav/dytg.png'),
                    introduction: "扫码一键核销",

                }, {
                    id: 806002,
                    path: '/kstg',
                    name: '快手团购',
                    navTitle: "团购 / 快手团购",
                    navImg: require('@/assets/img/nav/kstg.png'),
                    introduction: "扫码一键核销",

                },
                {
                    id: 806003,
                    path: '/mttg',
                    name: '美团团购',
                    navTitle: "团购 / 美团团购",
                    navImg: require('@/assets/img/nav/mttg.png'),
                    introduction: "扫码一键核销",

                },
            ]
        },
        ]
    },
    {
        id: 20,
        name: "报表",
        path: '/bbNav',
        img: require('@/assets/img/bbNav.png'),
        act_img: require('@/assets/img/actBbNav.png'),
        authId: '',
        data: [
            {
                id: 209,
                name: '报表导航',
                isNav: true,
                children: [{
                    id: 209001,
                    path: '/bbNav',
                    name: '报表导航',
                    navTitle: "报表导航 / 报表导航",
                    authId: '',
                },]
            },
            {
                id: 200,
                name: '订单报表',
                children: [{
                    id: 200001,
                    path: '/orderDetail',
                    name: '订单明细',
                    navTitle: "订单报表 / 订单明细",
                    navImg: require('@/assets/img/nav/ddmx.png'),
                    introduction: "订单单据明细",
                    authId: 'bb_ddmx',
                }, {
                    id: 200002,
                    path: '/mgjy',
                    name: '敏感交易',
                    navTitle: "订单报表 / 敏感交易",
                    navImg: require('@/assets/img/nav/mgjy.png'),
                    introduction: "敏感交易",
                    authId: 'bb_mgjy',
                }, {
                    id: 200003,
                    path: '/yyfx',
                    name: '运营分析',
                    navTitle: "订单报表 / 运营分析",
                    navImg: require('@/assets/img/nav/yyfx.png'),
                    introduction: "运营分析",
                    authId: 'bb_yyfx',
                },
                {
                    id: 200004,
                    path: '/ztph',
                    name: '桌台排行',
                    navTitle: "订单报表 / 桌台排行",
                    navImg: require('@/assets/img/nav/ztph.png'),
                    introduction: "桌台排行",
                    authId: 'bb_ztph',
                },
                    // {
                    //   id: 200005,
                    //   path: '/jbdz',
                    //   name: '交班对账',
                    //   navTitle: "订单报表 / 交班对账",
                    //   navImg: require('@/assets/img/nav/jbdz.png'),
                    //   introduction: "交班报表",
                    //   authId: 'bb_jbdz',
                    // },
                    //  {
                    //   id: 200005,
                    //   path: '/jbbb',
                    //   name: '交班报表',
                    //   navTitle: "订单报表 / 交班报表",
                    //   navImg: require('@/assets/img/nav/jbdz.png'),
                    //   introduction: "交班报表",
                    //   authId: 'bb_jbbb',
                    // },
                ]
            }, {
                id: 202,
                name: '菜品报表',
                children: [{
                    id: 202001,
                    path: '/cphz',
                    name: '菜品汇总',
                    navTitle: "菜品报表 / 菜品汇总",
                    navImg: require('@/assets/img/nav/cphz.png'),
                    introduction: "菜品汇总数据",
                    authId: 'bb_cphz',
                }, {
                    id: 202002,
                    path: '/cpmx',
                    name: '菜品明细',
                    navTitle: "菜品报表 / 菜品明细",
                    navImg: require('@/assets/img/nav/cpmx.png'),
                    introduction: "菜品明细数据",
                    authId: 'bb_cpmx',
                }, {
                    id: 202003,
                    path: '/cpph',
                    name: '菜品排行',
                    navTitle: "菜品报表 / 菜品排行",
                    navImg: require('@/assets/img/nav/cpph.png'),
                    introduction: "菜品排行数据",
                    authId: 'bb_cpph',
                }],

            },
            {
                id: 203,
                name: '营业报表',
                children: [{
                    id: 203001,
                    path: '/jbbb',
                    name: '交班报表',
                    navTitle: "营业报表 / 交班报表",
                    navImg: require('@/assets/img/nav/jbhz.png'),
                    introduction: "交班报表数据",
                    authId: 'bb_jbbb',
                }, {
                    id: 203002,
                    path: '/skhz',
                    name: '收款汇总',
                    navTitle: "营业报表 / 收款汇总",
                    navImg: require('@/assets/img/nav/skhz.png'),
                    introduction: "收款汇总数据",
                    authId: 'bb_skhz',
                }, {
                    id: 203003,
                    path: '/xshz',
                    name: '销售汇总',
                    navTitle: "营业报表 / 销售汇总",
                    navImg: require('@/assets/img/nav/xshz.png'),
                    introduction: "销售汇总数据",
                    authId: 'bb_xshz',
                }],

            },
            // {
            //   id: 203,
            //   name: '会员报表',
            //   children: [{
            //     id: 203001,
            //     path: '/hyXz',
            //     name: '会员新增',
            //     navTitle: "会员报表 / 会员新增"
            //   }, {
            //     id: 203002,
            //     path: '/xfHz',
            //     name: '会员消费',
            //     navTitle: "会员报表 / 会员消费"
            //   }, {
            //     id: 203003,
            //     path: '/xfMx',
            //     name: '消费明细',
            //     navTitle: "会员报表 / 消费明细"
            //   }, {
            //     id: 203004,
            //     path: '/jfHz',
            //     name: '积分汇总',
            //     navTitle: "会员报表 / 积分汇总"
            //   }, {
            //     id: 203005,
            //     path: '/jfMx',
            //     name: '积分明细',
            //     navTitle: "会员报表 / 积分明细"
            //   }, {
            //     id: 203006,
            //     path: '/ffHy',
            //     name: '付费会员',
            //     navTitle: "会员报表 / 付费会员"
            //   }, {
            //     id: 203007,
            //     path: '/sjMx',
            //     name: '升降明细',
            //     navTitle: "会员报表 / 升降明细"
            //   },]
            // },
        ]
    },
    {
        id: 50,
        name: "系统",
        img: require('@/assets/img/setNav.png'),
        act_img: require('@/assets/img/actSetNav.png'),
        path: '/szNav',
        authId: '',
        data: [
            {
                id: 509,
                name: '系统导航',
                isNav: true,
                children: [{
                    id: 509001,
                    path: '/szNav',
                    name: '系统导航',
                    navTitle: "系统导航 / 系统导航",
                    authId: '',

                },]
            }, {
                id: 501,
                name: '基础信息',
                children: [{
                    id: 501004,
                    path: '/mall',
                    name: '门店信息',
                    navTitle: "基础信息 / 门店信息",
                    navImg: require('@/assets/img/nav/mdxx.png'),
                    introduction: "连锁多门店档案",
                    authId: 'xt_mdxx',
                },
                {
                    id: 501003,
                    path: '/mallCls',
                    name: '门店区域',
                    navTitle: "门店管理 / 门店区域",
                    navImg: require('@/assets/img/nav/lsNavIcon/jc/mdqy.png'),
                    introduction: "门店区域管理",
                    authId: 'xt_mdqy'
                }, {
                    id: 501005,
                    path: '/user',
                    name: '员工信息',
                    navTitle: "基础信息 / 员工信息",
                    navImg: require('@/assets/img/nav/ygxx.png'),
                    introduction: "门店员工信息管理",
                    authId: 'xt_ygxx',
                },
                {
                    id: 501008,
                    path: '/userCls',
                    name: '员工分组',
                    navTitle: "门店管理 / 员工分组",
                    navImg: require('@/assets/img/nav/lsNavIcon/jc/ygfz.png'),
                    introduction: "员工分组管理",
                    authId: 'xt_ygfz'
                },
                {
                    id: 501007,
                    path: '/userPower',
                    name: '员工权限',
                    navTitle: "基础信息 / 员工权限",
                    navImg: require('@/assets/img/nav/ygqx.png'),
                    introduction: "为角色分配所需权限",
                    authId: 'xt_ygqx',
                },
                {
                    id: 501006,
                    path: '/remark',
                    name: '常用备注',
                    navTitle: "基础信息 / 常用备注",
                    navImg: require('@/assets/img/nav/cybz.png'),
                    introduction: "快捷设置备注信息",
                    authId: 'xt_cybz',
                },
                    // {
                    //     id: 501012,
                    //     path: '/fysz',
                    //     name: '费用收支',
                    //     navTitle: "资金账户 / 费用收支",
                    //     navImg: require('@/assets/img/nav/lsNavIcon/jc/fysz.png'),
                    //     introduction: "费用收支管理",
                    //     authId: 'fysh'
                    // }


                ]
            },

            {
                id: 503,
                name: '资金账户',
                children: [{
                    id: 503008,
                    path: '/acct',
                    name: '收款方式',
                    navTitle: "基础信息 / 收款方式",
                    navImg: require('@/assets/img/nav/skzh.png'),
                    introduction: "收款方式信息",
                    authId: 'xt_skfs',
                },
                {
                    id: 503009,
                    path: '/amtAcct',
                    name: '资金账户',
                    navTitle: "资金账户 / 资金账户",
                    navImg: require('@/assets/img/nav/lsNavIcon/jc/zjzh.png'),
                    introduction: "资金账户管理",
                    authId: 'xt_zjzh'
                },

                // {
                //     id: 503010,
                //     path: '/zjls',
                //     name: '资金流水',
                //     navTitle: "资金账户 / 资金流水",
                //     navImg: require('@/assets/img/nav/lsNavIcon/jc/zjls.png'),
                //     introduction: "资金流水管理",
                //     authId: 'xt_zjls'
                // },
                {
                    id: 503011,
                    path: '/fyxm',
                    name: '费用项目',
                    navTitle: "资金账户 / 费用项目",
                    navImg: require('@/assets/img/nav/lsNavIcon/jc/fyxm.png'),
                    introduction: "费用项目管理",
                    authId: 'xt_fyxm'
                },]
            },
            {
                id: 502,
                name: '其他信息',
                children: [
                    {
                        id: 502001,
                        path: '/device',
                        name: '设备管理',
                        navTitle: "其他信息 / 设备管理",
                        navImg: require('@/assets/img/nav/sbNav.png'),
                        introduction: "设备信息管理",
                        authId: 'xt_sbgl',



                    },
                ]
            },
            // {
            //   id: 500,
            //   name: '设置',
            //   children: [{
            //     id: 500001,
            //     path: '/device',
            //     name: '设备管理',
            //     navTitle: "设置 / 设备管理"
            //   },]
            // }
        ]
    },
]
export default cyNavList;


// WEBPACK FOOTER //
// ./src/assets/listData/cyNav.js